import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";
import { mockData } from "../../mock/payemtsmock";
import { MembershipDashboard } from "../../components/memberships/MembershipDashboard";
import { MembershipDashboardSkeleton } from "../../components/memberships/MembershipDashboardSkeleton";
import { membershipStatsAxios } from "../../services/membership/MembershipAxios";
import { MembershipData } from "../../types/membership";
import { useNavigate } from "react-router-dom";
import { decodeTokenService } from "../../services/decodeTokenService";

export const MembershipPage: React.FC = () => {
  const { language } = useAuth();
  const [stats, setStats] = useState<MembershipData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const email = decodeTokenService.getEmailFromToken();

  const getStats = async () => {
    try {
      setIsLoading(true);
      const stats = await membershipStatsAxios();

      setStats(stats);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  const renderContent = () => {
    if (isLoading) {
      return <MembershipDashboardSkeleton />;
    }

    if (!stats) {
      navigate("/plans");
      return
    }
    
    if (!stats.active_membership) {
      navigate("/plans");
      return
    }

    return <MembershipDashboard data={stats} />;
  };

  return (
    <div 
      className="min-h-screen bg-[#F5F6FA] px-16 pt-10 pb-16"
    >
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">
          {dictionary["membership"][language]}
        </h1>
        <div className="flex items-center gap-2 px-3 py-1 text-gray-500 rounded-lg">
          <Mail size={14} className="sm:w-4 sm:h-4" />
          <span className="text-xs sm:text-sm font-medium truncate max-w-[200px] sm:max-w-none">{email}</span>
        </div>
      </div>
      {renderContent()}
    </div>
  );
};
